<template lang="html">
  <div>
    <Modal class="modal" v-model="m_visible" footer-hide @on-cancel="close" width="840">
      <div id="download-modal">
        <p class="p1">投融资总趋势-{{tabTitle}}</p>
        <p class="p2">
          <span>地区：</span><template v-if="params.demostic == ''">全球</template><template v-if="params.demostic == '0'">国外</template><template v-if="params.demostic == '1' && params.address_id == ''">国内</template><template v-if="params.demostic == '1' && params.address_id != ''">{{params.address_id | deal('address')}}</template>
          <template v-if="params.s_time && params.e_time">
            <span>时间：</span>{{params.s_time}} - {{params.e_time}}
          </template>
        </p>
        <div class="chart_img">
            <img id="chart-image" src="">
        </div>
        <div class="mark">
          <img class="logo" v-if="!theme_switch" src="~pic/logo_whrite.png">
          <img class="logo" v-else src="~pic/logo.png">
          <p>说明：以动脉橙的搜索量为数据基础，以融资金额为统计对象，科学分析并计算出每一年度的融资金额的数量。</p>
        </div>
      </div>
      <div class="footer">
        <div @click="save">
          保存图片
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import watermark from 'watermarkjs'
import html2canvas from 'html2canvas'
export default {
  data() {
    return {
      m_visible: false
    }
  },
  props: ['visible', 'imgbase', 'tabTitle', 'params'],
  computed: {
    theme_switch() {
      return this.$store.state.theme_switch
    }
  },
  methods: {
    close() {
      this.m_visible = false
      this.$emit('closeecharts')
    },
    save() {
      html2canvas(document.getElementById('download-modal'),{scale: 1.5, allowTaint: true}).then((canvas) => { // canvas是个dom对象
        let save_url=canvas.toDataURL("image/png")
        let a = document.createElement('a')
        document.body.appendChild(a)
        a.href=save_url
        a.download= '投融资总趋势-' + this.tabTitle
        a.click()
      })
    }
  },
  created() {
    // console.log(this.params)
    this.m_visible = this.visible
  },
  mounted() {
    // watermark([this.imgbase, !this.theme_switch ? require('../../../assets/pic/watermark-white.png') : require('../../../assets/pic/watermark-gray.png')])
    // .image(watermark.image.center(1))
    // .then((img) => { // img是个dom对象
    // })
    document.getElementById('chart-image').setAttribute('src',this.imgbase)


  }
}
</script>

<style lang="stylus" scoped>
.modal
  >>> .ivu-modal
    top: 50%
    transform: translateY(-50%)
  >>> .ivu-modal-body
    padding: 40px 40px 20px
    background: #F5F5F5
  >>> .ivu-modal-mask
    background-color: rgba(0,0,0,.6)
  >>> .ivu-icon-ios-close
    &:hover
      color: rgba(250, 122, 80, 1)
#download-modal
  commonBgColor(#2A2F42, #ffffff)
  padding: 16px
  .p1
    commonColor(#E9E9EB, #333333)
    font-size: 16px
    text-align: center
    font-weight: bold
  .p2
    margin-top: 16px
    font-size: 12px
    line-height: 1
    commonColor(#E9E9EB, #333333)
    span
      commonColor(#bcbdc1, #999999)
      &+span
        margin-left: 30px
  .chart_img
    margin-top: 10px
    width: 720px
    height: 267px
  img
    width: 720px
    height: auto
  .mark
    margin-top: 16px
    display: flex
    align-items: center
    img
      // width: 84px
      width: 111px
      // height: 34px
      margin-right: 14px
    p
      commonColor(#bcbdc1, #999999)
.footer
  margin-top: 16px
  display: flex
  flex-direction: row-reverse
  div
    width: 80px
    height: 32px
    border-radius: 2px
    font-size: 14px
    color: #FFF
    background: rgba(250, 122, 80, 1)
    cursor: pointer
    display: flex
    justify-content: center
    align-items: center
    &:hover
      background: #FC9C7C
</style>
